import { lazy } from 'react'

export const UserAccountPersonal = lazy(() => import('pages/app-user-account-personal'))
export const Affiliation = lazy(() => import('pages/affiliation'))
export const SmartInstallmentReport = lazy(() => import('pages/app-sales/smartInstallment.component'))
export const SmartinstallmentsDashboard = lazy(() => import('pages/app-sales/smartinstallmentsDashboard.component'))
export const SmartRecoveryReport = lazy(() => import('pages/app-sales/smartRecovery.component'))
export const SubscriptionDashboard = lazy(() => import('pages/subscription-dashboard'))
export const SubscriptionManagement = lazy(() => import('pages/subscription-management'))
export const SubscriptionRFM = lazy(() => import('pages/app-sales/subscription-rfm.component'))
export const SubscriptionRetentionStrategies = lazy(() => import('pages/subscription-retention-strategies'))
export const SubscriptionStatus = lazy(() => import('pages/app-sales/subscription-status.component'))
export const MarketplaceAnalytics = lazy(() => import('pages/app-sales/marketplace-analytics.component'))
export const TemplateDashboard = lazy(() => import('pages/app-sales/templateDashboard.component'))
export const SubscriptionsHubTools = lazy(() => import('pages/subscriptions-hub-tools/component'))
export const Dashboard = lazy(() => import('pages/dashboard'))
export const DriveReport = lazy(() => import('pages/app-drive-report'))
export const Integration = lazy(() => import('pages/integration'))
export const Kajabi = lazy(() => import('pages/kajabi'))
export const PlatformTools = lazy(() => import('pages/app-platform-tools'))
export const Market = lazy(() => import('pages/market'))
export const Pixel = lazy(() => import('pages/pixel'))
export const BlackNovember = lazy(() => import('pages/black-november'))
export const CommunicationChat = lazy(() => import('pages/chat'))
export const WhatsappAutomations = lazy(() => import('pages/app-automations'))
export const Documents = lazy(() => import('pages/documents'))
export const MembersArea = lazy(() => import('pages/members-area/members-area.component'))
export const Onboarding = lazy(() => import('pages/onboarding'))
export const BoostSalesStrategy = lazy(() => import('pages/boost-sales-dashboard'))
export const BoostSalesChargeBack = lazy(() => import('pages/boost-sales-dashboard'))
export const BoostSalesManagement = lazy(() => import('pages/boost-sales-dashboard'))
export const BoostSalesManagementMyDashbaord = lazy(() => import('pages/boost-sales-dashboard'))
export const BoostSalesMetrics = lazy(() => import('pages/boost-sales-dashboard'))
export const BlipChatComponent = lazy(() => import('pages/blipChat'))
export const MembershipAdmin = lazy(() => import('pages/membership/membership.component'))
export const Product = lazy(() => import('pages/product/product.component'))
export const ConnectAppWebHook = lazy(() => import('pages/connect-app-webhook'))
export const AppCredentials = lazy(() => import('pages/app-credentials'))
export const WhatsappSupportConfig = lazy(() => import('pages/support-config'))
export const Payouts = lazy(() => import('pages/payouts'))
export const AuthWallet = lazy(() => import('pages/auth-wallet'))
export const HotmartPRO = lazy(() => import('pages/hotmart-pro'))
export const Shipments = lazy(() => import('pages/app-shipments'))
